<script setup lang="ts">
import type { DropeeMappedTaskItem } from '@/types/task'
import TheBottomSheet from '@/components/TheBottomSheet.vue'
import TaskModalPrizeBox from '@/components/TaskModalPrizeBox.vue'
import BaseButton from '@/components/base/BaseButton.vue'
import { ref } from 'vue'
import router from '@/router'
import { RouteName } from '@/routes'
import { T } from '@tolgee/vue'
import { useDailyPurchaseTask } from '@/composables/game/daily'

const props = defineProps<{
  show: boolean
  isClaiming: boolean
  task: DropeeMappedTaskItem | null
}>()
const emit = defineEmits<{
  (event: 'hide'): void,
  (event: 'claim'): void,
}>()

const { didDailyTaskPurchase } = useDailyPurchaseTask()
const isLoading = ref(false)

async function claim() {
  if (!props.task || props.task.isDone) {
    emit('hide')
    return
  }

  if (!didDailyTaskPurchase.value) {
    router.push({ name: RouteName.SHOP })
  } else {
    emit('claim')
  }
}
</script>

<template>
  <TheBottomSheet
    :show="show"
    @hide="$emit('hide')"
  >
    <div
      v-if="task"
      class="flex flex-col gap-y-6 items-center"
    >
      <img
        class="size-[120px] object-cover"
        :src="task.imageUrl"
      >
      <div class="flex flex-col items-center">
        <div class="text-light-white text-[24px] leading-8 font-bold -tracking-[0.48px]">
          {{ task.title }}
        </div>
        <div
          v-if="task.description"
          class="text-white/60 text-base font-semibold text-center"
        >
          {{ task.description }}
        </div>
      </div>
      <TaskModalPrizeBox
        v-if="task.reward"
        :reward="task.reward"
        :spins="task.spins"
        :tickets="task.tickets as number"
      />
      <BaseButton
        v-if="task.isDone"
        class="w-full mt-2"
        button-class="!bg-light-stone !text-black/[.67]"
        @click="$emit('hide')"
      >
        <T
          key-name="tasks.daily_question.come_back"
          default-value="Come back tomorrow"
        />
      </BaseButton>
      <BaseButton
        v-else
        class="mt-2 w-full"
        :disabled="task.isDone"
        :loading="isClaiming || isLoading"
        @click="claim"
      >
        <span
          v-if="!didDailyTaskPurchase"
        >{{ task.cta }}</span>
        <T
          v-else
          key-name="quests.mystery_task.check"
          default-value="Check"
        />
      </BaseButton>
    </div>
  </TheBottomSheet>
</template>

<style scoped>

</style>